import Constants from 'expo-constants';
import * as Permissions from 'expo-permissions';
import { useDispatch, useSelector } from 'react-redux';
import { RootAppState } from '../store';
import { loginAction, logoutAction } from './sessaoActions';
import { SessaoState } from './sessaoTypes';
import authApi from '../../apis/authApi';
import * as Notifications from 'expo-notifications';
import clienteApi from '../../apis/clienteApi';
import { useAlert } from '../alert/alertHooks';
import { useNavigation } from '@react-navigation/native';
import { Platform } from 'react-native';
import { useEmpresa } from '../empresa/empresaHooks';
import { usePedido } from '../pedido/pedidoHooks';

export const useSessao = (): [
  SessaoState,
  (email: string, senha: string) => void,
  () => void,
  () => void,
  (tokenGoogle: string) => void
] => {
  const dispatch = useDispatch();
  const sessao = useSelector((state: RootAppState) => state.sessao);
  const [mostrarAlert] = useAlert();
  const navigation = useNavigation();
  const [empresa] = useEmpresa();
  const [pedido, setPedido] = usePedido();

  const getNotifications = async () => {
    if (Platform.OS === 'web') {
      return;
    }
    try {
      let token = '';
      if (Constants.isDevice) {
        const { status: existingStatus } = await Permissions.getAsync(Permissions.NOTIFICATIONS);
        let finalStatus = existingStatus;
        if (existingStatus !== 'granted') {
          const { status } = await Permissions.askAsync(Permissions.NOTIFICATIONS);
          finalStatus = status;
        }
        if (finalStatus !== 'granted') {
          mostrarAlert(
            'Ah não :(',
            'Algo deu errado e você não receberá as notificações sobre seus pedidos.'
          );
          return;
        }
        token = (await Notifications.getExpoPushTokenAsync()).data;
        // console.log(token);
      } else {
        // mostrarAlert('Ah não :(', 'Sem notificações em emuladores.');
      }

      if (Platform.OS === 'android') {
        Notifications.setNotificationChannelAsync('default', {
          name: 'default',
          importance: Notifications.AndroidImportance.MAX,
          vibrationPattern: [0, 250, 250, 250],
          lightColor: '#FF231F7C'
        });
      }
      await clienteApi.updatePushToken(token);
    } catch (err) {
      console.log(err);
      mostrarAlert(
        'Ops...',
        'Ocorreu um erro e você não receberá notificações sobre seus pedidos. Tente refazer o login.'
      );
    }
  };

  const login = async (email: string, senha: string) => {
    try {
      const sessao = await authApi.login(email, senha);
      if (sessao) {
        const action = loginAction(sessao);
        dispatch(action);
        setTimeout(() => {
          getNotifications();
        }, 2000);
        if (empresa.verificaClientes && !sessao.cliente.verificado) {
          navigation.navigate('VerificacaoPage');
        } else {
          navigation.goBack();
        }
      } else {
        throw new Error('Credenciais inválidas.');
      }
    } catch (err) {
      mostrarAlert('Ops...', err.data || err.message);
    }
    // navigation.goBack();
  };

  const logout = () => {
    setPedido({ ...pedido, cliente: null });
    const action = logoutAction();
    dispatch(action);
  };

  const revalidate = async () => {
    try {
      const sessao = await authApi.revalidate();
      const action = loginAction(sessao);
      dispatch(action);
      setTimeout(() => {
        getNotifications();
      }, 2000);
    } catch (err) {
      const action = logoutAction();
      dispatch(action);
    }
  };

  const loginGoogle = async (tokenGoogle: string) => {
    try {
      const sessao = await authApi.loginGoogle(tokenGoogle);
      if (sessao) {
        const action = loginAction(sessao);
        dispatch(action);
        setTimeout(() => {
          getNotifications();
        }, 2000);
        if (empresa.verificaClientes && !sessao.cliente.verificado) {
          navigation.navigate('VerificacaoPage');
        } else {
          navigation.goBack();
        }
      } else {
        throw new Error('Credenciais inválidas.');
      }
    } catch (err) {
      mostrarAlert('Ops...', err.data || err.message);
    }
    // navigation.goBack();
  };

  return [sessao, login, logout, revalidate, loginGoogle];
};

export const useSessaoOnly = (): [SessaoState, () => void] => {
  const sessao = useSelector((state: RootAppState) => state.sessao);
  const dispatch = useDispatch();

  const revalidate = async () => {
    try {
      const sessao = await authApi.revalidate();
      const action = loginAction(sessao);
      dispatch(action);
    } catch (err) {
      const action = logoutAction();
      dispatch(action);
    }
  };

  return [sessao, revalidate];
};
